import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    estudios: [],
    tipoEstudios: [],
  },

  getters: {
    getEstudios: (state) => state.estudios,

    getTipoEstudios: (state) => state.tipoEstudios,
  },

  mutations: {
    SET_ESTUDIOS(state, estudios) {
      state.estudios = estudios;
    },

    SET_TIPO_ESTUDIOS(state, tipoEstudios) {
      state.tipoEstudios = tipoEstudios;
    },
  },

  actions: {
    async fetchTipoEstudios({ commit }) {
      await axios
        .get('PoliciaCuadrantes/EstadoFuerza/estudios')
        .then((response) => {
          commit('SET_TIPO_ESTUDIOS', response.data.data);
        });
    },

    async fetchEstudiosByPersonal({ commit }, idPersonal) {
      await axios
        .get(`PoliciaCuadrantes/EstadoFuerza/personal/${idPersonal}/estudios`)
        .then((response) => {
          commit('SET_ESTUDIOS', response.data.data);
        });
    },

    async saveEstudiosPersonal(context, estudiosPersonal) {
      await axios
        .post(`EonCloud/EstadoFuerza/personal/${estudiosPersonal.fk_idPersonal}/estudios`, estudiosPersonal)
        .then(() => {
          context.commit('SET_SNACKBAR_MESSAGE', 'Registro de estudios agregado correctamente', {
            root: true,
          });
        });
    },

    async updateEstudiosPersonal(_, estudiosPersonal) {
      await axios
        .put(`EonCloud/EstadoFuerza/personal/${estudiosPersonal.fk_idPersonal}/estudios/${estudiosPersonal.id}`, estudiosPersonal);
    },
  },
};
